import styled from 'styled-components'

import { brandSecondary, media } from '../../../../../../utils/style-utils'

interface Props {
  left: boolean
}

export const ArrowWrapper = styled.div<Props>`
  position: absolute;
  z-index: 2;
  height: 100%;
  width: 100px;
  cursor: pointer;

  ${(props) => (props.left ? 'left: 0;' : 'right: 0;')}

  &:hover .arrow-icon {
    fill: ${brandSecondary};
  }

  ${media.lg`
    width: 100px;
  `}

  ${media.md`
    display: none;
  `}
`
